"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EobSource = exports.EobType = void 0;
var EobType;
(function (EobType) {
    EobType[EobType["Eob"] = 1] = "Eob";
    EobType[EobType["Payback"] = 0] = "Payback";
})(EobType = exports.EobType || (exports.EobType = {}));
var EobSource;
(function (EobSource) {
    EobSource["claim"] = "Claim";
    EobSource["copay"] = "Copay";
})(EobSource = exports.EobSource || (exports.EobSource = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/eob.ts
// module id = 2811
// module chunks = 0